(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractTypeDeleteController',ContractTypeDeleteController);

    ContractTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ContractType'];

    function ContractTypeDeleteController($uibModalInstance, entity, ContractType) {
        var vm = this;
        vm.contractType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ContractType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
